import React, { useState } from "react";

import { toast } from "react-toastify";
import PhoneInput from 'react-phone-input-2';

import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { useSelector } from 'react-redux';
import axios from 'axios';
import userServices from 'services/httpService/userAuth/userServices';
import { useMutation } from 'react-query';
import { useParams } from 'react-router-dom';
import ErrorService from 'services/formatError/ErrorService';
import { serviceCharges, endPoint } from 'config/config';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';

const CARD_OPTIONS = {
  iconStyle: 'solid',
  style: {
    base: {
      iconColor: 'white',
      color: 'white',
      fontWeight: 500,
      // paddingVertical: 100,
      fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
      fontSize: '16px',
      fontSmoothing: 'antialiased',
      ':-webkit-autofill': {
        color: 'white',
      },
      '::placeholder': {
        color: 'white',
      },
    },
    invalid: {
      iconColor: 'red',
      color: 'red',
    },
  },
};

const CardField = ({ onChange }) => (
  <div className='FormRow text-white'>
    <CardElement options={CARD_OPTIONS} onChange={onChange} />
  </div>
);

const Field = ({
  label,
  id,
  type,
  placeholder,
  required,
  autoComplete,
  value,
  onChange,
}) => (
  <div className='FormRow'>
    <label htmlFor={id} className='FormRowLabel'>
      {label}
    </label>
    <input
      // className='input-styl h-12 px-2 py-2'
      className='input-styl mx-2 h-12 px-2 py-2 w-20 my-2'
      id={id}
      type={type}
      placeholder={placeholder}
      required={required}
      autoComplete={autoComplete}
      value={value}
      onChange={onChange}
    />
  </div>
);

const SubmitButton = ({ processing, error, children, disabled }) => (
  <button
    className={`btn-styl my-4 ${error ? 'btn-error' : ''}`}
    type='submit'
    disabled={processing || disabled}
  >
    {processing ? 'Processing...' : children}
  </button>
);

const ErrorMessage = ({ children }) => (
  <div className='ErrorMessage' role='alert'>
    <svg width='16' height='16' viewBox='0 0 17 17'>
      <path
        fill='#FFF'
        d='M8.5,17 C3.80557963,17 0,13.1944204 0,8.5 C0,3.80557963 3.80557963,0 8.5,0 C13.1944204,0 17,3.80557963 17,8.5 C17,13.1944204 13.1944204,17 8.5,17 Z'
      />
      <path
        fill='#6772e5'
        d='M8.5,7.29791847 L6.12604076,4.92395924 C5.79409512,4.59201359 5.25590488,4.59201359 4.92395924,4.92395924 C4.59201359,5.25590488 4.59201359,5.79409512 4.92395924,6.12604076 L7.29791847,8.5 L4.92395924,10.8739592 C4.59201359,11.2059049 4.59201359,11.7440951 4.92395924,12.0760408 C5.25590488,12.4079864 5.79409512,12.4079864 6.12604076,12.0760408 L8.5,9.70208153 L10.8739592,12.0760408 C11.2059049,12.4079864 11.7440951,12.4079864 12.0760408,12.0760408 C12.4079864,11.7440951 12.4079864,11.2059049 12.0760408,10.8739592 L9.70208153,8.5 L12.0760408,6.12604076 C12.4079864,5.79409512 12.4079864,5.25590488 12.0760408,4.92395924 C11.7440951,4.59201359 11.2059049,4.59201359 10.8739592,4.92395924 L8.5,7.29791847 L8.5,7.29791847 Z'
      />
    </svg>
    {children}
  </div>
);

const ResetButton = ({ onClick }) => (
  <button type='button' className='ResetButton' onClick={onClick}>
    <svg width='32px' height='32px' viewBox='0 0 32 32'>
      <path
        fill='#FFF'
        d='M15,7.05492878 C10.5000495,7.55237307 7,11.3674463 7,16 C7,20.9705627 11.0294373,25 16,25 C20.9705627,25 25,20.9705627 25,16 C25,15.3627484 24.4834055,14.8461538 23.8461538,14.8461538 C23.2089022,14.8461538 22.6923077,15.3627484 22.6923077,16 C22.6923077,19.6960595 19.6960595,22.6923077 16,22.6923077 C12.3039405,22.6923077 9.30769231,19.6960595 9.30769231,16 C9.30769231,12.3039405 12.3039405,9.30769231 16,9.30769231 L16,12.0841673 C16,12.1800431 16.0275652,12.2738974 16.0794108,12.354546 C16.2287368,12.5868311 16.5380938,12.6540826 16.7703788,12.5047565 L22.3457501,8.92058924 L22.3457501,8.92058924 C22.4060014,8.88185624 22.4572275,8.83063012 22.4959605,8.7703788 C22.6452866,8.53809377 22.5780351,8.22873685 22.3457501,8.07941076 L22.3457501,8.07941076 L16.7703788,4.49524351 C16.6897301,4.44339794 16.5958758,4.41583275 16.5,4.41583275 C16.2238576,4.41583275 16,4.63969037 16,4.91583275 L16,7 L15,7 L15,7.05492878 Z M16,32 C7.163444,32 0,24.836556 0,16 C0,7.163444 7.163444,0 16,0 C24.836556,0 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 Z'
      />
    </svg>
  </button>
);

function PaymentPage() {
  // const params = useParams();

  // console.log('-------------', params.phNo);

  const [nameOnCard, setnameOnCard] = useState('');

  const [totalAmount, settotalAmount] = useState(5);

  const [creditSlect, setcreditSlect] = useState(100);

  const [phNo, setphNo] = useState('');

  const [Checked1, setChecked1] = React.useState(true);

  const [Checked2, setChecked2] = React.useState(false);

  const [Checked3, setChecked3] = React.useState(false);

  // const [myEmail, setmyEmail] = useState("");

  // const [address, setaddress] = useState("");

  // const [contactNo, setcontactNo] = useState();
  // const [setlat] = useState("");
  // const [setlong] = useState("");

  const fianllypay = useMutation(
    (addCustomerCard) =>
      userServices.commonPostService('/pay', addCustomerCard),
    {
      onError: (error) => {
        //// seterrorMsg(ErrorService.uniformError(error));

        toast.error(ErrorService.uniformError(error));
      },
      onSuccess: (result) => {
        // console.log('1st pay', result);
        console.log('data=>', result.data);

        if (result.data.hasOwnProperty('error')) {
          //// alert(result.data.error);
          toast.error(result.data.error);
        }

        // Handle server response (see Step 4)
        handleServerResponse(result.data);

        ////  setsuccessData(data.data);

        //// deleteShop();

        ////// history.push('/ordersshopper');
      },
    }
  );

  function handleServerResponse(response) {
    // console.log(response);
    console.log('status', response.success);

    console.log('its run');

    if (response.error) {
      // Show error from server on payment form
    } else if (response.requires_action) {
      console.log('in if', response);
      // Use Stripe.js to handle required card action
      console.log(response.payment_intent_client_secret);
      // alert('hello');
      stripe
        .handleCardAction(response.payment_intent_client_secret)
        .then(handleStripeJsResult);
    } else {
      /////  deleteShop();
      toast.success('SMS has been purchased successfully');
      ///// deleteShop();

      ////  alert('payment done');
      // Show success message
    }
  }

  async function handleStripeJsResult(result) {
    console.log('-------------result---------------');

    console.log(result);
    if (result.error) {
      //// alert(result.error.message);
      toast.error(result.error.message);
      // Show error in payment form
    } else {
      let data = {
        phNo: phNo,
        credit: creditSlect,
        payment_intent_id: result.paymentIntent.id,

        totalAmount: totalAmount,
      };
      // eslint-disable-next-line
      const response = await axios
        .post(endPoint + '/pay', data)
        .then(function (confirmResult) {
          console.log('------cinfirm----resutk');
          console.log(confirmResult);
          return confirmResult;
        })

        .then(handleServerResponse);

      // console.log('payment done');
    }
  }

  function changeaddress(value) {
    /// formik.setFieldValue('address', value);
  }

  // const [success, setSuccess] = useState(false);
  // const stripe = useStripe();
  // const elements = useElements();

  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null);
  const [cardComplete, setCardComplete] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState(null);

  const [setBillingDetails] = useState({
    email: '',
    phone: '',
    name: '',
    address: '',
  });

  ///const [address, setaddress] = useState(localStorageData("address"));
  const handleSubmit = async (event) => {
    event.preventDefault();

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: elements.getElement(CardElement),
      billing_details: {
        name: nameOnCard,
      },
    });

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }

    if (error) {
      elements.getElement('card').focus();
      return;
    }

    if (cardComplete) {
      setProcessing(true);
    }

    // const payload = await stripe.createPaymentMethod({
    //   type: 'card',
    //   card: elements.getElement(CardElement),
    //   /////  billing_details: billingDetails,
    // });

    if (!error) {
      if (paymentMethod) {
        const cardElement = elements.getElement(CardElement);
        let token = await stripe.createToken(cardElement);
        console.log(token);

        let data = {
          token: token,
          credit: creditSlect,
          payment_method_id: paymentMethod.id,
          phNo: '+' + phNo,
          totalAmount: totalAmount,
        };

        /// console.log(data);

        fianllypay.mutate(data);
        /////// write own logic

        // if (localStorageData("_id")) {
        //   if (myEmail === "" || nameOnCard === "") {
        //     toast.error("Please fill all fields");
        //   } else {
        //     let data = {
        //       token: token,
        //       userData: getLocalUserdata(),

        //       payment_method_id: paymentMethod.id,

        //       ///  orderDetail: userCart[params.shopId],
        //       address: address,
        //       email: myEmail,
        //       contactNo: contactNo,
        //     };

        //     fianllypay.mutate(data);
        //   }
        // } else {
        //   toast.error("Login Required");
        //   /////   history.push('/signin');
        // }
      }
    } else {
      toast.error('Card info Not Correct');
    }

    setProcessing(false);

    // if (payload.error) {
    //   setError(payload.error);
    // } else {
    //   setPaymentMethod(payload.paymentMethod);
    // }
  };

  const reset = () => {
    setError(null);
    setProcessing(false);
    setPaymentMethod(null);
    setBillingDetails({
      email: '',
      phone: '',
      name: '',
    });
  };

  return paymentMethod ? (
    <div className='Result'>
      <div className='ResultTitle' role='alert'>
        Payment successful
      </div>
      <div className='ResultMessage'>
        Thanks for trying Stripe Elements. No money was charged, but we
        generated a PaymentMethod: {paymentMethod.id}
      </div>
      <ResetButton onClick={reset} />
    </div>
  ) : (
    <form className='' onSubmit={handleSubmit}>
      {fianllypay.isLoading ? (
        <>
          <CircularProgress />
        </>
      ) : (
        <div className=''>
          {/* <label>one SMS = ${serviceCharges}</label> */}
          <div className='my-2 '>What number will you search from? </div>

          <PhoneInput
            country={'us'}
            name='phoneNumber'
            id='phoneNumber'
            type='number'
            containerClass=' placeholder-white text-white bg-color-grey rounded-xl text-sm shadow '
            inputClass='phone-styl focus:outline-none   focus:ring rounded-xl w-full ease-linear transition-all duration-150'
            searchClass='searchClass text-black'
            dropdownClass='bg-black dropdown-styl'
            enableSearch
            placeholder='Phone Number'
            // onChange={formik.handleChange}
            onChange={(phone) => setphNo(phone)}
            // onBlur={formik.handleBlur}
            // value={formik.values.phoneNumber}
          />

          {/* <TextField
            label='Phone Number'
            variant='filled'
            id='sms'
            // type='number'
            required
            onChange={(e) => setphNo(e.target.value)}
            style={{
              color: 'white',
              backgroundColor: '#282828',
            }}
            fullWidth
            InputLabelProps={{
              style: { color: '#999999' },
            }}
            InputProps={{
              disableUnderline: true,
            }}
            sx={{ input: { color: 'white' } }}

            ////value={localStorageData('contactNo')}
            //// disabled
          /> */}

          <div className=' mt-2 mb-2'>How many credits do you want? </div>

          <div className='flex my-2'>
            <input
              type='radio'
              id='credits1'
              name='credits'
              onClick={(e) => {
                settotalAmount(5);
                setcreditSlect(e.target.value);

                setChecked1(true);
                setChecked2(false);
                setChecked3(false);
              }}
              value='100'
              checked={Checked1}
              className='accent-white text-lg w-5 h-5 radio-styl'
            />
            <div className='mx-3 my-1 relative text-white'>
              100 credits (5$)
            </div>
          </div>

          <div className='flex my-2'>
            <input
              type='radio'
              id='credits2'
              name='credits'
              onClick={(e) => {
                setcreditSlect(e.target.value);

                settotalAmount(9);
                setChecked2(true);
                setChecked1(false);
                setChecked3(false);
              }}
              value='200'
              className='accent-white text-lg radio-styl'
              checked={Checked2}
            />
            <div className='mx-3 my-1 relative text-white'>
              200 credits (9$)
            </div>
          </div>

          <div className='flex my-2'>
            <input
              type='radio'
              id='credits3'
              name='credits'
              onClick={(e) => {
                settotalAmount(20);
                setcreditSlect(e.target.value);
                setChecked3(true);
                setChecked1(false);
                setChecked2(false);
              }}
              value='500'
              className='accent-white text-lg w-5 h-5 radio-styl'
              checked={Checked3}
            />
            <div className='mx-3 my-1 relative text-white'>
              500 credits (20$)
            </div>
          </div>

          <div className=' my-4'>
            <div className='text-color-grey'>
              1 credits / SMS results (text)
            </div>
            <div className='text-color-grey mt-2'>
              2 credits / MMS results (image)
            </div>
          </div>

          <TextField
            label='Name'
            id='nameoncard'
            type='nameoncard'
            placeholder='Name on card'
            required
            onChange={(e) => setnameOnCard(e.target.value)}
            style={{
              color: 'white',
              backgroundColor: '#282828',
              borderRadius: 5,
            }}
            fullWidth
            InputLabelProps={{
              style: { color: '#999999' },
            }}
            variant='filled'
            InputProps={{
              disableUnderline: true,
            }}
            sx={{ input: { color: 'white' } }}
            ////value={localStorageData('contactNo')}
            //// disabled
          />

          <div className='FormGroup my-2 bg-[#282828] h-12 rounded text-white p-3 py-5 pb-10'>
            <CardField
              className='py-2'
              onChange={(e) => {
                setError(e.error);
                setCardComplete(e.complete);
              }}
            />
          </div>
          {error && <ErrorMessage>{error.message}</ErrorMessage>}
          <SubmitButton
            processing={processing}
            error={error}
            disabled={!stripe}
          >
            Pay ${totalAmount}
          </SubmitButton>

          <div className=' my-4'>
            <div className='text-color-grey'>This will apply to</div>
          </div>
        </div>
      )}
    </form>
  );
}

export default PaymentPage;
